import { Check, ShieldCheck, X, Minus } from "lucide-react";
import { Panel } from "@/components/PageHeader";

const Consent = ({ c }) => {
  const [cls, Icon, txt] = c.value === true ? ["border-emerald-200 bg-emerald-50 text-emerald-700", Check, "Consenso dato"]
    : c.value === false ? ["border-rose-200 bg-rose-50 text-rose-700", X, "Non concesso"] : ["border-slate-200 bg-slate-50 text-slate-400", Minus, "Non disponibile"];
  return (
    <div className="flex items-center justify-between gap-3 py-2" data-testid={`consent-${c.key}`}>
      <span className="text-sm text-slate-700">{c.label}</span>
      <span className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs ${cls}`} data-testid={`consent-${c.key}-value`}><Icon className="h-3 w-3" />{txt}</span>
    </div>
  );
};

export const CustomerProfile = ({ profile }) => {
  if (!profile) return null;
  return (
    <div className="mb-6 grid gap-6 lg:grid-cols-3" data-testid="customer-profile">
      <Panel title="Anagrafica completa" className="lg:col-span-2" testId="customer-anagrafica">
        <div className="grid gap-6 p-5 sm:grid-cols-2">
          {profile.groups.filter((g) => g.fields.length).map((g) => (
            <div key={g.title}>
              <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">{g.title}</div>
              <dl className="space-y-1.5">
                {g.fields.map((f) => (
                  <div key={f.label} className="flex gap-3 text-sm"><dt className="w-36 shrink-0 text-slate-500">{f.label}</dt><dd className="min-w-0 break-words text-slate-800" data-testid={`profile-field-${f.label.toLowerCase().replace(/\s+/g, "-")}`}>{f.value}</dd></div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </Panel>
      <Panel title={<span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" />Autorizzazioni privacy</span>} testId="customer-privacy">
        <div className="divide-y divide-slate-100 px-5 py-2">
          {profile.consents.map((c) => <Consent key={c.key} c={c} />)}
          {profile.signed !== null && <Consent c={{ key: "signed", label: "Modulo privacy firmato", value: profile.signed }} />}
        </div>
        {profile.updated && <div className="border-t border-slate-100 px-5 py-2 text-xs text-slate-400">Ultimo aggiornamento: {profile.updated}</div>}
      </Panel>
    </div>
  );
};
